import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";

export class BaseView {
  constructor(options) {
    options = options || {};
    this.id = options.id;
    this.targetId = options.targetId || null;
    this.baseTemplate = options.baseTemplate || null;
    this.isActive = false;
    this.activeClass = options.activeClass || "activeView";
    this.viewClass = options.viewClass || "";
    this.hasBoundEvents = false;
    this.initialized = false;
    this.requiresLogin = options.requiresLogin;
    this.hideEvents = [];
    this.showEvents = [];
    this.removeListenerFunctions = [];
  }
  promptIfNotLoggedIn(callback) {
    if (typeof callback === "function") {
      callback();
    }
  }
  setShowEvent(eventString) {
    if ($.inArray(eventString, this.showEvents) == -1) {
      var _this = this;
      this.addListener(eventString, function (event) {
        if (_this.getRequiresLogin() === true) {
          _this.promptIfNotLoggedIn(function () {
            //TLCLogger.log("ShowEvent HEARD", event);
            _this.show(event);
          }, _this.canceledLoginCallback);
        } else {
          _this.show(event);
        }
      })
      this.showEvents.push(eventString);
    }
  }
  addListener(eventString, callback) {
    const guid = TLCEventManager.addListener(eventString, callback);
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(eventString, guid));
  }
  removeEvents(){}
  cleanup(){
    // remove events
    this.removeEvents();
    // remove listeners
    this.removeListenerFunctions.forEach((remove) => remove());
  }
  canceledLoginCallback() {
    // This will be overridden
  }
  setHideEvent(eventString) {
    //TODO: check if typeof array to allow array or single event to be passed
    if ($.inArray(eventString, this.hideEvents) == -1) {
      var _this = this;
      this.addListener(eventString, function (event) {
        //TLCLogger.log("HideEvent HEARD", eventString);
        _this.hide();
      });
      this.hideEvents.push(eventString);
    }
  }
  hide() {
    this.isActive = false;
    $("#" + this.id).removeClass(this.activeClass);
    $("#" + this.id).hide();
  }
  show(event) {
    if (this.initialized === false) {
      this.initialized = true;
      this.init(event);
    } else {
      this.load(event);
      this.reFocus(event);
    }
    this.isActive = true;
    $("#" + this.id).addClass(this.activeClass);
    $("#" + this.id).show();
  }
  load(event) {
    TLCLogger.log("BaseView.load");
    TLCLogger.log(event);
  }
  reFocus() { }
  isLoading() {
    this.loading = true;
  }
  doneLoading() {
    this.loading = false;
  }
  baseTemplateRenderCallback(data) {
    //TLCLogger.log("baseTemplateRenderCallback", "override me if necessary");
  }
  init(event) {
    //TLCLogger.log(this.id + " init called");
    this.initProperties(event);

    if (this.targetId) {
      var target = $("#" + this.targetId);
      var newEle = $("<div></div>")
        .attr("id", this.id)
        .addClass(this.viewClass);

      target.append(newEle);

      this.$view = newEle;
    } else {
      this.$view = $("#" + this.id);
    }

    this.$view.addClass(this.activeClass);

    var _this = this;

    if (this.baseTemplate !== null) {
      TemplateEngine.fetch(this.baseTemplate, this.id, event, function (data) {
        _this.baseTemplateRenderCallback(event, data);
        _this.load(event);
        _this.reFocus(event);
      });
    } else {
      _this.render(event);
    }
  }
  initProperties(event) {
    //TLCLogger.log("init properties called from baseView");
  }
  render(event) {
    $("#" + this.id).text(
      "Page Id: " + this.id + ". Please override render function."
    );
  }
  getRequiresLogin() {
    return this.requiresLogin;
  }
}


